<template>
  <main class="guests-page">
    <FacilitiesPanel />
  </main>
</template>

<script>
import FacilitiesPanel from "@/components/FacilitiesPanel.vue";

export default {
  name: "FacilitiesPage",
  components: { FacilitiesPanel },
};
</script>

<style src="@/css/GuestsPage.css" />
